import { Row, Col, Button, Text } from "rsuite";
import { useNavigate } from "react-router-dom";
import { useOrderCreation } from "../context/OrderCreationContext";
import { authUserData } from "../../../../../service";

export const OrderComplete: React.FC = () => {
  const { newCreatedOrderID } = useOrderCreation();
  const navigate = useNavigate();
  const authUser = authUserData();

  return (
    <Row>
      <Col xs={24} md={24} style={{ textAlign: 'left' }}>
        <br />
        <Text weight="extrabold">
          <h5>系統已收到您的預約 !</h5>
        </Text>
        <br />
        {authUser && (
          <Button
            appearance="default"
            onClick={() => navigate(`/rider/order/${newCreatedOrderID}/payment/ecpay/credit-card`)}
          >
            進行付款
          </Button>
        )}
      </Col>
    </Row>
  );
};
